import { render } from "./vresourcesedit.vue?vue&type=template&id=d4e9dabc&scoped=true"
import script from "./vresourcesedit.vue?vue&type=script&lang=js"
export * from "./vresourcesedit.vue?vue&type=script&lang=js"

import "./vresourcesedit.vue?vue&type=style&index=0&id=d4e9dabc&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/生产环境总后台manage.jsyinba.com/jsgeneral/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d4e9dabc"]])

export default __exports__